<template>
  <div class="modal fade" :class="$props.class" tabindex="-1" ref="modal1">
    <div :class="dialogClass">

      <div class="modal-content">

        <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            :aria-label="$t('dss.button.close')"
            :title="$t('dss.button.close')"/>

        <slot>MODAL CONTENT</slot>

      </div>

    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Modal } from 'bootstrap';
import { Logger } from 'oidc-client-ts';

export default defineComponent({
  name: 'StihlModal',
  emits: ['modalClosed'],
  props: {
    class: { type: String, default: null },
    dialogClass: { type: String, default: 'modal-dialog modal-dialog-centered' },
  },
  computed: {
    modal(): Modal {
      const modalEL = this.$refs.modal1 as HTMLDivElement; // document.getElementById('SelectSyncModal')
      return Modal.getOrCreateInstance(modalEL);
    },
  },
  mounted() {
    Logger.debug('modal', 'mounted');
    this.modal.show();
    (this.$refs.modal1 as HTMLDivElement)
        .addEventListener('hidden.bs.modal', () => this.$emit('modalClosed'));
  },
  unmounted() {
    this.modal.hide();
  },
});
</script>

<style scoped>
.modal .btn-close {
  position: absolute;
  top: 0;
  right: 0;

  --bs-btn-close-bg: url("/assets/icons/close.svg");
  --bs-btn-close-opacity: 1;
  --bs-btn-close-hover-opacity: 1;

  background-color: black;

  padding: .5rem;
}

.modal .btn-close:dir(rtl) {
  left:0;
  right: auto;
}

.modal .btn-close:hover {
  background-color: var(--orange-base);
  transition: background-color .3s ease-out;
}

.modal-content {
  padding: var(--stihl-modal-content-padding, 3.5rem);
  gap: var(--stihl-modal-content-gap);
}
</style>
